import { Icon, ChevronDownIcon } from "@/components/ui/icon";
import { View } from "@/components/ui/view";
import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Select, SelectTrigger, SelectInput, SelectIcon, SelectPortal, SelectContent, SelectItem } from "@/components/ui/select";
import { ScrollView } from "react-native-gesture-handler";
import { HStack } from "@/components/ui/hstack";
import { Center } from "@/components/ui/center";
import { Pressable } from "@/components/ui/pressable";
import { GlobalState } from "@/containers/GlobalState";

import i18n from 'i18n-js';
import Moment from 'moment';
import { FlatList } from 'react-native-gesture-handler';
import React, { useEffect, useState, useContext } from 'react';
import { useWindowDimensions } from 'react-native';
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useDispatch, useSelector } from "react-redux";
import { RRule, rrulestr } from 'rrule';
import Footer from '../../components/basic/Footer';
import ModalConfirm from '../../components/basic/ModalConfirm';
import PressableElement from "../../components/basic/PressableElement";
import SwitchableElement from '../../components/basic/SwitchableElement';
import WorkflowListElement from "../../components/workflow/WorkflowListElement";
import useIsMounted from "../../hooks/mounted";
import { backendRequest } from '../../stores/thunks';
import ModalCalendar from '../modals/ModalCalendar';
import ModalTime from '../modals/ModalTime';

const freq = ['never', 'yearly', 'monthly', 'weekly', 'daily']

const RuleEdit = ({ navigation, plan, task, startDate, contact, save }) => {

    const user = useSelector((state) => state.user)
    const planned = useSelector((state) => state.planned)
    const dispatch = useDispatch()
    const mounted = useIsMounted()
    const { inAColors } = useContext(GlobalState)

    const [schedule, setSchedule] = useState(plan ? rrulestr(plan.schedule) : null)
    const [date, setDate] = useState(schedule && Moment(schedule.options.dtstart) || startDate && Moment(startDate).startOf('day').toISOString() || Moment().startOf('day').toISOString())
    const [repeat, setRepeat] = useState(() => {
        if (null == schedule || schedule.options.freq == 3 && schedule.options.count == 1) {
            return -1
        }
        return schedule.options.freq
    })
    const [allDay, setAllDay] = useState(schedule ? Moment(schedule.options.dtstart).format('HH:mm') == '00:00' : true)
    const [deletePlan, setDeletePlan] = useState(false)

    const [showModalCalendar, setShowModalCalendar] = useState(false)
    const [selectedDates, setSelectedDates] = useState([])
    const [showModalTime, setShowModalTime] = useState(false)
    const [showModal, setShowModal] = useState(false)

    useEffect(() => {
        return () => {
            if (!mounted()) {
                if (deletePlan) {
                    if (plan.id) {
                        dispatch(backendRequest('DELETE_PLAN_INLINE', '/planned/' + plan.id, null, 'DELETE', false)).then(plan => {
                            console.log('DELETE', plan.result)
                        })
                    }
                } else {
                    if (save) {
                        const rule = new RRule({
                            freq: repeat == -1 ? RRule.DAILY : repeat,
                            wkst: RRule.MO,
                            dtstart: new Date(date),
                            interval: 1,
                            count: repeat == -1 ? 1 : null
                        })
                        if (plan?.schedule != rule.toString()) {
                            if (null == schedule) {
                                dispatch(backendRequest('CREATE_PLAN_INLINE', '/planned', {
                                    "createFor": contact?.toUser.id || user.id,
                                    "workflow": task.workflowId,
                                    "startAt": date,
                                    "schedule": rule.toString()
                                }, 'POST', false)).then(plan => {
                                    console.log('CREATE PLAN', plan.result)
                                }).catch(error => console.log('CREATE PLAN', error))
                            } else {
                                dispatch(backendRequest('UPDATE_PLAN_INLINE', '/planned/' + plan.id, {
                                    "startAt": date,
                                    "doneAt": undefined,
                                    "schedule": rule.toString()
                                }, 'PUT', false)).then(plan => {
                                    console.log('UPDATE PLAN', plan.result)
                                }).catch(error => console.log('UPDATE PLAN', error))
                            }
                        }
                    }
                }
            }
        }
    }, [mounted])

    const toggleAllDay = () => {
        if (!allDay) {
            setDate(Moment(date).startOf('day'))
        }
        setAllDay(!allDay)
    };

    const closeModal = (confirmed) => {
        setShowModal(false)
        if (confirmed) {
            setDeletePlan(true)
            navigation.goBack()
        }
    }

    const showCalender = () => {
        setSelectedDates(rulesToSelected(date))
        setShowModalCalendar(true)
    }

    const onMonthChange = (newDate) => {
        setSelectedDates(rulesToSelected(newDate))
    }

    // TODO: hide plans of deleted workflows
    const rulesToSelected = (actDate) => {
        return planned.plans.map(plan => rrulestr(plan.schedule).between(new Date(Moment(actDate).startOf('month')), new Date(Moment(actDate).endOf('month'))))
            .flat().map(day => ({
                date: day,
                textStyle: { color: inAColors.secondary["900"] },
                style: { backgroundColor: inAColors.primary["100"] },
                allowDisabled: true,
            }))
    }

    return (
        <VStack space='xl' className={`w-screen px-3 `}>
            <PressableElement header={i18n.t('scheduleWorkflow.date')} mainText={Moment(date).format('dddd, DD. MMMM YYYY')} pressed={() => showCalender()} />
            <SwitchableElement header={i18n.t('scheduleWorkflow.time')} mainText={i18n.t('scheduleWorkflow.allDay')} isChecked={allDay} onToggle={() => toggleAllDay()} />
            {!allDay && <PressableElement mainText={i18n.t('scheduleWorkflow.oclock', { time: Moment(date).format('HH:mm') })} pressed={() => setShowModalTime(!showModalTime)} />}
            <VStack space='md'>
                <Text className="text-2xl text-secondary-900">{i18n.t('scheduleWorkflow.repeat')}</Text>
                <View className="mb-1 px-3">
                    <Select accessibilityLabel={i18n.t('scheduleWorkflow.repeat')} onValueChange={itemValue => setRepeat(itemValue)} className="border rounded-md text-secondary-900">
                        <SelectTrigger variant="outline" size="lg">
                            <SelectInput placeholder={i18n.t('scheduleWorkflow.repeat')} value={i18n.t('scheduleWorkflow.' + freq[repeat + 1])} />
                            <SelectIcon className="absolute right-3 text-secondary-900" as={ChevronDownIcon} />
                        </SelectTrigger>
                        <SelectPortal>
                            <SelectContent>
                                <SelectItem label={i18n.t('scheduleWorkflow.never')} value={-1} />
                                <SelectItem label={i18n.t('scheduleWorkflow.daily')} value={RRule.DAILY} />
                                <SelectItem label={i18n.t('scheduleWorkflow.weekly')} value={RRule.WEEKLY} />
                                <SelectItem label={i18n.t('scheduleWorkflow.monthly')} value={RRule.MONTHLY} />
                                <SelectItem label={i18n.t('scheduleWorkflow.yearly')} value={RRule.YEARLY} />
                            </SelectContent>
                        </SelectPortal>
                    </Select>
                </View>
            </VStack>
            {schedule && <PressableElement header={i18n.t('scheduleWorkflow.delete')} mainText={i18n.t('scheduleWorkflow.deletePlan')} color='text-error-600' pressed={() => setShowModal(true)} />}
            <ModalCalendar showModal={showModalCalendar} setShowModal={setShowModalCalendar} date={date} onDateChange={setDate} onMonthChange={onMonthChange} customDatesStyles={selectedDates} />
            <ModalTime showModal={showModalTime} setShowModal={setShowModalTime} title='scheduleWorkflow.startTime' date={date} setDate={setDate} />
            <ModalConfirm showModal={showModal} closeModal={closeModal} title='scheduleWorkflow.deletePlan' text='scheduleWorkflow.deletePlanText' options={{ task: task.title }} />
        </VStack >
    );
}

export default function ScheduleWorkflow({ navigation, route }) {
    const { task, plans, startDate, contact, toTask, planId } = route.params

    const window = useWindowDimensions()
    const [page, setPage] = useState(0)
    const insets = useSafeAreaInsets()
    const [save, setSave] = useState(false)

    const saveChanges = () => {
        setSave(true)
    }

    const actions = [
        { icon: '' },
        { icon: 'home', text: 'footer.home', component: 'Home' },
        { icon: 'check', text: 'footer.create', component: startDate ? 'Planner' : toTask ? 'BACK2' : 'BACK', params: { isEdit: true, contact: contact }, exec: saveChanges }
    ]

    useEffect(() => {
        navigation.setOptions({ info: i18n.t(contact ? 'scheduleWorkflow.infoOther' : 'scheduleWorkflow.details', { name: contact?.toUser.preferredName }) })
        setPage(plans.findIndex(plan => plan?.id == planId))
    }, [])

    function handleScroll(event) {
        let actPage = Math.round(event.nativeEvent.contentOffset.x / window.width)
        if (actPage != page) {
            setPage(actPage)
        }
    }

    const renderItem = ({ item, index }) => {
        return <RuleEdit key={'r' + index} navigation={navigation} plan={item} task={task} startDate={startDate} contact={contact} save={save} />
    }

    return (
        <View className="flex-1 bg-secondary-50">
            <ScrollView scrollIndicatorInsets={{ right: 1 }} contentContainerStyle={{ paddingBottom: 70 + insets.bottom }} className="flex-1 bg-secondary-50 py-3">
                <VStack space='2xl' className="px-3">
                    <VStack space='sm'>
                        <Text className="text-2xl text-secondary-900">{i18n.t('scheduleWorkflow.workflow')}</Text>
                        <View className="-mx-3">
                            <WorkflowListElement taskid={task.id} navigation={navigation} showProgress={false} disabled={true} />
                        </View>
                    </VStack>
                    <Center className="flex-1">
                        {plans.length > 1 &&
                            <HStack space='xs' className="absolute bottom-2">
                                {plans.map((plan, p) => <Pressable key={"U" + p} className={` ${page == p ? "bg-primary-900" : "bg-secondary-50"} p-1 rounded-full border-[2px] border-primary-900 `} />)}
                            </HStack>
                        }
                    </Center>
                </VStack>
                <FlatList
                    horizontal={true}
                    data={plans}
                    decelerationRate={0}
                    snapToInterval={window.width}
                    snapToAlignment='center'
                    initialScrollIndex={page}
                    getItemLayout={(data, index) => ({
                        length: window.width,
                        offset: window.width * index,
                        index,
                    })}
                    onScroll={handleScroll}
                    scrollEventThrottle={256}
                    renderItem={renderItem}
                    keyExtractor={(item, index) => item?.id || 'T' + index}
                />
            </ScrollView>
            <Footer navigation={navigation} actions={actions} />
        </View>
    );
}
